import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrScholarsParticipateBoxLayoutParticipateItemCls: string;
			communityPlsrScholarsParticipateBoxLayoutStepWrapperCls: string;
			communityPlsrScholarsParticipateBoxLayoutEnterItemCls: string;
		}
	},

	slug: string
}

class Participate extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Scholars Participate Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrScholarsParticipateBoxLayoutParticipateItemCls || '', 'community_plsr_scholars_participate', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrScholarsParticipateBoxLayoutStepWrapperCls || '', 'community_plsr_scholars_participate', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrScholarsParticipateBoxLayoutEnterItemCls || '', 'community_plsr_scholars_participate', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Participate;